import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ugfqwtar8: FaireProductEntity = {
  token: "p_7ugfqwtar8",
  type: "product",
  name: "Bro Knit Sweater, Cocoa",
  brandToken: "b_4ivwmhbmyd",
  brandName: "SpearmintLOVE",
  imageUrl:
    "https://cdn.faire.com/fastly/cc6505b1499ebc55306736dc7a34f2915e6b0c1c4aed3e252cc53528dea89fa9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6cafb4a9fb9515c53d4b868d2b44391625184645049534aedf7d2ff4c2e40b5c.jpeg",
    "https://cdn.faire.com/fastly/9a31afc63e92ccff2e20427ee72a8520c3885182c49ac8b095ff58dd5e453727.png",
  ],
  priceDollars: 21,
  description:
    "\nFor the coolest Brother! These cozy knit sweaters are perfectly oversized and made from 100% sheep wool. \n\n * Made from 100% Sheep Wool \n * Imported \nCARE INSTRUCTIONS\n\nWashing: hand wash recommended\nDry cleaning: do not dry clean\nBleaching: do not bleach\nDrying: hang dry\n",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:41.973Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
